import { SITE_URL, getAbsoluteSiteUrl } from './blogSeoMetadata';

/** Open Graph / Twitter Card images must be PNG or JPG at ~1200×630. SVG is not rendered by major scrapers. */
export const OG_IMAGE_WIDTH = 1200;
export const OG_IMAGE_HEIGHT = 630;
export const OG_IMAGE_TYPE = 'image/jpeg';

export const OG_HOME_IMAGE_PATH = '/images/marketing/og-home.jpg';
export const OG_DEFAULT_IMAGE_PATH = '/images/marketing/og-default.jpg';
export const OG_COMPANION_IMAGE_PATH = '/images/marketing/og-companion.jpg';

export const OG_HOME_IMAGE_URL = getAbsoluteSiteUrl(OG_HOME_IMAGE_PATH);
export const OG_DEFAULT_IMAGE_URL = getAbsoluteSiteUrl(OG_DEFAULT_IMAGE_PATH);
export const OG_COMPANION_IMAGE_URL = getAbsoluteSiteUrl(OG_COMPANION_IMAGE_PATH);

export const OG_HOME_IMAGE_ALT = 'CalorieScience nutrition practice platform';
export const OG_DEFAULT_IMAGE_ALT = 'CalorieScience';
export const OG_COMPANION_IMAGE_ALT = 'CalorieScience Companion app preview';

/** Publisher logo for JSON-LD — real PNG, not SVG. */
export const PUBLISHER_LOGO_URL = `${SITE_URL}/logo.png`;
